import styled from "styled-components"

export interface StyledOverviewProps {
  hide_filters: boolean
}
export interface StyledOverviewToolbarProps {
  hide_filters: boolean
}
export interface StyledOverviewFiltersProps {
  visible: boolean
}
export interface StyledOverviewInputProps {
  desktop_only: boolean
}
export interface StyledOverviewActionProps {
  mobile_only: boolean
}

export const StyledOverview = styled.div<StyledOverviewProps>`
  ${props =>
    props.hide_filters
      ? `
    `
      : `
        @media (min-width: ${props.theme.breakPoints.tablet}) {
            margin-top: calc(-96px - 24px);
        }
        @media (max-width: ${props.theme.breakPoints.tablet}) {
            margin-top: calc(-72px + 24px);
        }
    `}
`
export const StyledOverviewToolbar = styled.div<StyledOverviewToolbarProps>`
  ${props =>
    props.hide_filters
      ? `
        display: none;
    `
      : `
        background: ${props.theme.colors.darkGrey};
        padding: 24px;
        margin-bottom: 24px;
    `}
`
export const StyledOverviewMobileTools = styled.div`
  @media (min-width: ${props => props.theme.breakPoints.tablet}) {
    display: none;
  }
  @media (max-width: ${props => props.theme.breakPoints.tablet}) {
    & > div {
      margin: 16px 0 0 0;
      &:nth-of-type(1) {
        margin: 0;
      }
    }
  }
`
export const StyledOverviewFilterToggle = styled.div`
  @media (max-width: ${props => props.theme.breakPoints.tablet}) {
    border: 1px solid ${props => props.theme.colors.white};
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    & p {
      ${props => props.theme.mixins.bold}
      color: ${props => props.theme.colors.white};
    }
    & svg {
      color: ${props => props.theme.colors.white};
    }
  }
`
export const StyledOverviewFilters = styled.div<StyledOverviewFiltersProps>`
  @media (min-width: ${props => props.theme.breakPoints.tablet}) {
  }
  @media (max-width: ${props => props.theme.breakPoints.tablet}) {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: ${props => props.theme.colors.darkGrey};
    z-index: 100000;

    ${props =>
      props.visible
        ? `
            opacity: 1;
            pointer-events: initial;
        `
        : `
            opacity: 0;
            pointer-events: none;        
        `}
  }
`
export const StyledOverviewFiltersHeader = styled.header`
  @media (min-width: ${props => props.theme.breakPoints.tablet}) {
    display: none;
  }
  @media (max-width: ${props => props.theme.breakPoints.tablet}) {
    display: flex;
    border-bottom: 1px solid ${props => props.theme.colors.white20};

    & p {
      padding: 24px;
      ${props => props.theme.mixins.bold}
      color: ${props => props.theme.colors.white};
    }
  }
`
export const StyledOverviewFiltersHeaderBack = styled.div`
  padding: 0 24px;
  display: flex;
  align-items: center;
  border-right: 1px solid ${props => props.theme.colors.white20};

  & svg {
    color: ${props => props.theme.colors.white};
  }
`
export const StyledOverviewFiltersContent = styled.div`
  @media (min-width: ${props => props.theme.breakPoints.tablet}) {
    display: grid;
    grid-column-gap: 12px;
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: ${props => props.theme.breakPoints.tablet}) {
    padding: 24px;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-row-gap: 8px;
  }
`
export const StyledOverviewInput = styled.div<StyledOverviewInputProps>`
  @media (min-width: ${props => props.theme.breakPoints.tablet}) {
    & > div {
      margin: 0;
    }
  }
  ${props =>
    props.desktop_only &&
    `
        @media (max-width: ${props.theme.breakPoints.tablet}) {
            display: none;
        } 
    `}
`
export const StyledOverviewResults = styled.div`
  display: flex;
  flex-direction: column;
`
export const StyledOverviewItem = styled.div`
  margin-top: 24px;

  &:nth-of-type(1) {
    margin-top: 0;
  }
`
export const StyledOverviewAction = styled.div<StyledOverviewActionProps>`
  display: flex;
  justify-content: center;
  margin: 24px 0 0 0;
  ${props =>
    props.mobile_only &&
    `
        @media (min-width: ${props.theme.breakPoints.tablet}) {
            display: none;
        }
    `}
`
export const StyledOverviewAlert = styled.p`
  display: flex;
  justify-content: center;
  ${props => props.theme.mixins.bold}
  padding: 24px 0;
  max-width: 100%;
  text-align: center;
`
